export const PHASE_PREPARE = "prepare";
export const PHASE_EXERCISE = "exercise";
export const PHASE_ANSWER = "answer";
export const PHASE_RESULT = "result";